function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { backArrowSvg } from "../../svg";
import PhoneInput from "react-phone-input-2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var durationTypes = [{
  value: "0-30 (Days)",
  order: 1
}, {
  value: "1-2 (Months)",
  order: 2
}, {
  value: "2-6 (Months)",
  order: 3
}, {
  value: "More than 6 Months",
  order: 4
}];
var StepTwo = function StepTwo(_ref) {
  var setStep = _ref.setStep,
    possessionDuration = _ref.possessionDuration,
    setPossessionDuration = _ref.setPossessionDuration,
    moveInDuration = _ref.moveInDuration,
    setMoveInDuration = _ref.setMoveInDuration,
    mobile = _ref.mobile,
    onChange = _ref.onChange,
    validator = _ref.validator,
    setIsTouched = _ref.setIsTouched,
    setInputFocused = _ref.setInputFocused,
    mobileHasError = _ref.mobileHasError,
    comment = _ref.comment,
    setComment = _ref.setComment,
    isInputFocused = _ref.isInputFocused,
    mobileNumberIsValid = _ref.mobileNumberIsValid,
    onFormSubmit = _ref.onFormSubmit;
  var isValidMoveInDuration = function isValidMoveInDuration(moveInValue) {
    var _durationTypes$find, _durationTypes$find2;
    if (!possessionDuration) return true;
    var possessionOrder = (_durationTypes$find = durationTypes.find(function (type) {
      return type.value === possessionDuration;
    })) === null || _durationTypes$find === void 0 ? void 0 : _durationTypes$find.order;
    var moveInOrder = (_durationTypes$find2 = durationTypes.find(function (type) {
      return type.value === moveInValue;
    })) === null || _durationTypes$find2 === void 0 ? void 0 : _durationTypes$find2.order;
    return moveInOrder >= possessionOrder;
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex text-base md:text-lg font-semibold justify-between py-3",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-1 cursor-pointer",
        onClick: function onClick() {
          return setStep(function (prev) {
            return prev - 1;
          });
        },
        children: [backArrowSvg, /*#__PURE__*/_jsx("button", {
          className: "text-primary text-sm md:text-base",
          children: "Back to Step 1"
        })]
      }), /*#__PURE__*/_jsxs("p", {
        className: "text-sm md:text-base",
        children: ["Step ", /*#__PURE__*/_jsx("span", {
          className: "text-primary text-base md:text-lg",
          children: "2"
        }), /*#__PURE__*/_jsx("span", {
          className: " text-xs md:text-sm",
          children: "/2"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "pt-3 flex  items-center",
        children: /*#__PURE__*/_jsx("h2", {
          className: "font-semibold",
          children: "Possession Timeline"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-wrap justify-between items-center ",
        children: durationTypes.map(function (type) {
          return /*#__PURE__*/_jsx("div", {
            onClick: function onClick() {
              setPossessionDuration(type.value);
              setMoveInDuration(null);
            },
            className: "w-[45%] cursor-pointer border rounded-[10px] p-2 my-2 lg:whitespace-nowrap xl:whitespace-nowrap ".concat(possessionDuration === type.value ? "bg-primary" : ""),
            children: /*#__PURE__*/_jsx("button", {
              className: "".concat(possessionDuration === type.value ? "text-white" : ""),
              children: type.value
            })
          });
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "pt-3 flex  items-center",
        children: /*#__PURE__*/_jsx("h2", {
          className: "font-semibold",
          children: "When are you planning to move-in ?"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-wrap justify-between items-center ",
        children: durationTypes.map(function (type) {
          return /*#__PURE__*/_jsx("div", {
            onClick: function onClick() {
              return isValidMoveInDuration(type.value) && setMoveInDuration(type.value);
            },
            disabled: !isValidMoveInDuration(type.value),
            className: "w-[45%] cursor-pointer border rounded-[10px] p-2 my-2  lg:whitespace-nowrap xl:whitespace-nowrap ".concat(moveInDuration === type.value ? "bg-primary" : "").concat(!isValidMoveInDuration(type.value) ? "opacity-50 cursor-not-allowed" : "", " "),
            children: /*#__PURE__*/_jsx("button", {
              className: "".concat(moveInDuration === type.value ? "text-white" : ""),
              children: type.value
            })
          });
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-4",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-left",
          children: "Alternate Phone Number"
        }), /*#__PURE__*/_jsxs("div", {
          className: " h-12 mt-2",
          children: [/*#__PURE__*/_jsx(PhoneInput, {
            country: "in",
            countryCodeEditable: false,
            containerClass: "bg-white h-10 rounded outline-none border-none ".concat(isInputFocused ? "outline-none " : ""),
            onlyCountries: ["in", "hk", "id", "kw", "my", "om", "qa", "sa", "sg", "ae", "gb", "eu", "us", "th"],
            containerStyle: {
              width: "100%",
              boxShadow: "0px",
              border: "none",
              outline: "none",
              borderRadius: "none",
              marginTop: "-1.5px",
              height: "100%"
            },
            inputStyle: _defineProperty(_defineProperty({
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "none"
            }, "border", "2px solid #EBEAF2"), "backgroundColor", "#FFFFFF"),
            buttonStyle: _defineProperty({
              backgroundColor: "#FFFFFF",
              border: "none"
            }, "border", "2px solid #EBEAF2"),
            isValid: validator,
            onChange: onChange,
            value: mobile,
            enableSearch: true,
            onBlur: function onBlur() {
              setIsTouched(true);
              setInputFocused(false);
            },
            onFocus: function onFocus() {
              return setInputFocused(true);
            },
            inputClass: ""
          }), mobileHasError && /*#__PURE__*/_jsx("div", {
            className: "mb-6",
            children: /*#__PURE__*/_jsx("p", {
              className: "text-left text-red-400 text-sm mt-1 ",
              children: "Please enter a valid number"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-2",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "text-left",
          children: "Any additional info?"
        }), /*#__PURE__*/_jsx("textarea", {
          type: "text",
          className: " text-black w-full text-grey-900 h-16 lg:h-12 xl:h-16 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3] mt-2",
          onChange: function onChange(e) {
            return setComment(e.target.value);
          },
          value: comment
        })]
      }), /*#__PURE__*/_jsx("button", {
        className: "w-full text-white p-3 rounded-[10px] disabled:cursor-not-allowed disabled:bg-[#adadad] bg-primary",
        onClick: function onClick() {
          onFormSubmit();
        },
        children: "Submit"
      })]
    })]
  });
};
export default StepTwo;